<template>
  <div class="container">
 
    <el-form ref="form" :model="form" label-width="120px">
    <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
      <el-tab-pane label="安全设置" name="first">
        <div>
          <el-form-item label="聊呗密码">
            <el-input ></el-input>
          </el-form-item>   
        </div>

      </el-tab-pane>

      <el-tab-pane label="常用语" name="fourth">

       <el-button>添加常用语</el-button>  

        <el-table :data="form.wages" style="width: 100%"  >
            <el-table-column   prop="danwei" label="描述"></el-table-column>
            <el-table-column  label="操作">
              <template slot-scope="scope">
                <el-button
                  @click.native.prevent="deleteRow(scope.$index, formData.address)"  type="text"  size="small">
                  移除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
      </el-tab-pane>

     
      <el-tab-pane label="黑名单" name="third">

       

      </el-tab-pane>
   
     
    </el-tabs>
  </el-form>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        activeName: 'first',
        userList:[],
        form: {
          wages:[
            {
              "danwei":"你好",
            
            }
          ],

        
          users:[],
          name: '',
          region: '',
          date1: '',
          date2: '',
          delivery: false,
          type: [],
          resource: '',
          desc: ''
        }
      };
    },
    methods: {
      handleClick(tab, event) {
        console.log(tab, event);
      }
    }
  };
</script>